import React, { Fragment, useEffect, useState } from "react";

import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import { mergeStyleSets, PrimaryButton } from "@fluentui/react";


interface ReactSelectorProps {
    id: string;
    value: any;
    defaultValue?: any;
    multiline?: boolean;
    onChange: (styleElementName: string, value: any) => void;
}

const classNames = mergeStyleSets({
    editorViewport: {
        minHeight: 80,
        maxHeight: 300,
        overflow: 'auto',
        border: '2px solid var(--druid-color-border)',
        borderRadius: 4,
        boxSizing: 'border-box'
    },
    editor: {
        minHeight: 76,
        outline: 'none',
        fontFamily: '"Fira code", "Fira Mono", Consolas, Menlo, monospace',
        fontSize: 12,
        lineHeight: 18,
        selectors: {
            '& > pre, & > textarea': {
                minHeight: 76
            }
        }
    },
    textarea: {
        outline: 'none',
        ':hover': {
            border: `2px solid red`,

        }
    },
    addDefaultTemplateButton: {
        display: 'flex',
        marginTop: 5,
        marginLeft: 'auto'
        // float: 'right'
    }
});
export const ReactSelector = (props: ReactSelectorProps) => {
    const { id, value, onChange, defaultValue } = props;

    const [reactValue, setReactValue] = useState(value);

    useEffect(() => {
        setReactValue(value || "");
    }, [value]);

    return (
        <Fragment>
            {/* <TextField multiline={props.multiline} defaultValue={value}  /> */}

            <div className={classNames.editorViewport}>
                <Editor
                    className={classNames.editor}
                    value={reactValue}
                    defaultValue={reactValue}
                    onValueChange={code => setReactValue(code)}
                    onBlur={(e: any, newValue?: string) => { onChange(id, e.target.value) }}
                    highlight={code => code && highlight(code, languages.js, "jsx")}
                    padding={10}
                    textareaClassName={classNames.textarea}
                />
            </div>

            {defaultValue && <PrimaryButton className={classNames.addDefaultTemplateButton} text="Add default template" onClick={() => { onChange(id, defaultValue); setReactValue(defaultValue) }} />}

        </Fragment>
    );
}
